/* El Quarto — vista previa del carrito (cajon lateral). Ver Carrito R01.
   - Lo abre SOLO el boton de la bolsa del header ([data-eq-bolsa-btn]), en
     todas las paginas. Sumar un producto no lo abre.
   - Un solo gesto: el panel entra con desaceleracion larga y los bloques se
     registran ADENTRO mientras todavia viaja (recorte + fundido, el registro de
     Contacto). El estado final se fija inline; las animaciones no dejan fill.
   - Los datos los arma sections/eq-bolsa.liquid (stock y otros formatos no
     estan en /cart.js). Cantidades optimistas; la red corre en cola y la
     ultima respuesta del servidor manda.
   - El contador del header lo pinta eq-cart.js desde `eq:cart`: el carrito es
     la unica fuente. */
const { mount, reduced, money } = window.EQ;
const SEC = 'eq-bolsa';

mount('[data-eq-bolsa]', (root) => {
  const panel = root.querySelector('[data-eq-bolsa-panel]');
  const velo = root.querySelector('[data-eq-bolsa-velo]');
  if (!panel || !velo) return () => {};
  const cfg = {
    umbral: Number(root.dataset.umbral) || 6000000,
    cuotas: Number(root.dataset.cuotas) || 3,
    vinilos: root.dataset.vinilos || '/collections/all',
    cds: root.dataset.cds || '/collections/all',
    cassettes: root.dataset.cassettes || '/collections/all',
    checkout: root.dataset.checkout || '/checkout'
  };
  const ROOT = (window.EQ_SHOP && window.EQ_SHOP.routes && window.EQ_SHOP.routes.root) || '/';
  const lento = reduced();

  const leer = (doc) => {
    const s = doc.querySelector('[data-eq-bolsa-data]');
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  };
  let D = leer(document) || { count: 0, subtotal: 0, items: [], sug: [] };
  let abierto = false, volverA = null, overflowAntes = '', paddingAntes = '', tFoco = 0, prog = null;
  let cola = Promise.resolve(), pend = 0, animando = 0, diferido = null;

  // ---- dibujo -----------------------------------------------------------
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const $ = (c) => '$ ' + money(c);
  const fondo = (img) => img ? ' style="background-image:url(\'' + esc(img) + '\')"' : '';
  const X = '<svg viewBox="0 0 14 14" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M1.5 1.5l11 11"/><path d="M12.5 1.5l-11 11"/></svg>';
  const MENOS = '<svg viewBox="0 0 14 2" width="10" height="2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M1 1h12"/></svg>';
  const MAS = '<svg viewBox="0 0 14 14" width="10" height="10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M7 1v12"/><path d="M1 7h12"/></svg>';
  const CAMION = '<svg viewBox="0 0 28 16" width="20" height="12" fill="none" stroke="#1f9d5c" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12V3h15v9"/><path d="M16 6h5l4 4v2h-3"/><circle cx="7" cy="12.5" r="2.2"/><circle cx="20" cy="12.5" r="2.2"/></svg>';
  // la flecha de "Pedilo" (snippets/eq-icon.liquid, 'arrow', 13x10)
  const FLECHA_DOT = '<svg viewBox="0 0 16 12" width="13" height="10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 6h13"/><path d="M9.8 1.8L14 6l-4.2 4.2"/></svg>';
  const FLECHA ='<svg viewBox="0 0 16 12" width="14" height="11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 6h13"/><path d="M9.8 1.8L14 6l-4.2 4.2"/></svg>';

  const recalcular = () => {
    D.count = D.items.reduce((s, it) => s + it.n, 0);
    D.subtotal = D.items.reduce((s, it) => s + it.p * it.n, 0);
  };
  const progreso = () => (cfg.umbral > 0 ? Math.min(1, D.subtotal / cfg.umbral) : 1);

  const html = () => {
    const items = D.items, hay = items.length > 0;
    const falta = Math.max(0, cfg.umbral - D.subtotal);
    const cuenta = D.count === 1 ? '1 artículo' : D.count + ' artículos';
    let h = '<div class="eq-bolsa__head">' +
      '<div class="eq-bolsa__top" data-eq-b>' +
        '<div class="eq-bolsa__tit"><h2 class="eq-bolsa__h">Tu bolsa</h2><span class="eq-bolsa__n" aria-live="polite">' + cuenta + '</span></div>' +
        '<button type="button" class="eq-bolsa__x" data-eq-act="cerrar" aria-label="Cerrar la bolsa">' + X + '</button>' +
      '</div>';
    if (hay) {
      h += '<div class="eq-bolsa__envio" data-eq-b>' +
        (falta > 0
          ? '<div class="eq-bolsa__falta">Te faltan <strong>' + $(falta) + '</strong> para el envío gratis</div>'
          : '<div class="eq-bolsa__listo">' + CAMION + '<span>Tu pedido tiene envío gratis</span></div>') +
        '<div class="eq-bolsa__barra"><span data-eq-barra class="' + (falta === 0 ? 'is-ok' : '') + '"></span></div>' +
      '</div>';
    }
    h += '<div class="eq-bolsa__sep"></div></div>';

    h += '<div class="eq-bolsa__list" data-eq-bolsa-list>';
    items.forEach((it) => {
      const k = esc(it.key), max = it.max || 9;
      h += '<div class="eq-bolsa__item" data-eq-b data-eq-item data-key="' + k + '">' +
        '<a class="eq-bolsa__cover" href="' + esc(it.href) + '" aria-label="' + esc(it.t) + '"' + fondo(it.img) + '></a>' +
        '<div class="eq-bolsa__info">' +
          '<a class="eq-bolsa__t" href="' + esc(it.href) + '">' + esc(it.t) + '</a>' +
          '<span class="eq-bolsa__a">' + esc(it.a) + '</span>' +
          '<span class="eq-bolsa__f">' + esc(it.fmt) +
            // preventa: solo la marca (la fecha queda en la ficha)
            (it.pre ? ' · <span class="eq-bolsa__pre">Preventa</span>' : '') +
          '</span>' +
          '<div class="eq-bolsa__ctl">' +
            '<div class="eq-bolsa__qty">' +
              '<button type="button" data-eq-act="menos" data-key="' + k + '" aria-label="Quitar uno"' + (it.n <= 1 ? ' disabled' : '') + '>' + MENOS + '</button>' +
              '<span aria-live="polite">' + it.n + '</span>' +
              '<button type="button" data-eq-act="mas" data-key="' + k + '" aria-label="Sumar uno"' + (it.n >= max ? ' disabled' : '') + '>' + MAS + '</button>' +
            '</div>' +
            '<button type="button" class="eq-bolsa__rm" data-eq-act="quitar" data-key="' + k + '">Quitar</button>' +
          '</div>' +
        '</div>' +
        '<div class="eq-bolsa__pr"><span class="eq-bolsa__tot">' + $(it.p * it.n) + '</span>' +
          (it.n > 1 ? '<span class="eq-bolsa__cu">' + $(it.p) + ' c/u</span>' : '') + '</div>' +
      '</div>';
    });
    if (!hay) {
      h += '<div class="eq-bolsa__vacia" data-eq-b>' +
        '<span class="eq-bolsa__vt">Tu bolsa está vacía</span>' +
        '<p class="eq-bolsa__vp">Los discos que sumes van a aparecer acá.</p>' +
        // tres botones (el de "Pedilo" de los catalogos), del ancho del rotulo
        // mas largo: los circulos de la flecha caen en la misma vertical
        '<div class="eq-bolsa__vas">' +
          [['Ver vinilos', cfg.vinilos], ['Ver CDs', cfg.cds], ['Ver cassettes', cfg.cassettes]].map((b) =>
            '<a class="eq-dotbtn eq-dotbtn--46" href="' + esc(b[1]) + '"><span>' + b[0] + '</span><span class="eq-dotbtn__dot">' + FLECHA_DOT + '</span></a>'
          ).join('') +
        '</div>' +
      '</div>';
    }
    if (hay && D.sug && D.sug.length) {
      h += '<div class="eq-bolsa__sug" data-eq-b><div class="eq-bolsa__sl">También en otro formato</div><div class="eq-bolsa__sls">';
      D.sug.slice(0, 2).forEach((s) => {
        h += '<div class="eq-bolsa__sr">' +
          '<a class="eq-bolsa__sc" href="' + esc(s.href) + '" aria-label="' + esc(s.t) + '"' + fondo(s.img) + '></a>' +
          '<div class="eq-bolsa__sb"><a class="eq-bolsa__st" href="' + esc(s.href) + '">' + esc(s.t) + '</a><span class="eq-bolsa__sd">' + esc(s.a + ' · ' + s.fmt) + '</span></div>' +
          '<span class="eq-bolsa__sp">' + $(s.p) + '</span>' +
          '<button type="button" class="eq-bolsa__sa" data-eq-act="sug" data-key="' + esc(s.v) + '" aria-label="Sumar ' + esc(s.t) + ' (' + esc(s.fmt) + ')">' + MAS + '</button>' +
        '</div>';
      });
      h += '</div></div>';
    }
    h += '</div>';

    if (hay) {
      const cu = cfg.cuotas > 1 ? cfg.cuotas + ' cuotas sin interés de ' + $(D.subtotal / cfg.cuotas) : 'Pagás en un solo pago';
      h += '<div class="eq-bolsa__pie" data-eq-b>' +
        '<div class="eq-bolsa__subr"><span class="eq-bolsa__subl">Subtotal</span><span class="eq-bolsa__subm">' + $(D.subtotal) + '</span></div>' +
        '<div class="eq-bolsa__cuotas">' + cu + ' · El envío se calcula al finalizar</div>' +
        '<a class="eq-bolsa__cta" href="' + esc(cfg.checkout) + '"><span>Finalizar compra</span>' + FLECHA + '</a>' +
        '<div class="eq-bolsa__seguir"><button type="button" data-eq-act="cerrar">Seguir comprando</button></div>' +
      '</div>';
    }
    return h;
  };

  // redibuja conservando el scroll de la lista, el foco y la barra (que
  // transiciona desde el valor anterior, no desde cero)
  const render = () => {
    const f = document.activeElement;
    const foco = f && panel.contains(f) && f.dataset && f.dataset.eqAct ? { act: f.dataset.eqAct, key: f.dataset.key || '' } : null;
    const lista = panel.querySelector('[data-eq-bolsa-list]');
    const top = lista ? lista.scrollTop : 0;
    panel.innerHTML = html();
    const nl = panel.querySelector('[data-eq-bolsa-list]');
    if (nl) nl.scrollTop = top;
    const barra = panel.querySelector('[data-eq-barra]');
    const p = progreso();
    if (barra) {
      // La barra es nueva en cada redibujo y nace en scaleX(0): cualquier
      // lectura de layout (el scrollTop de arriba) le calcula el estilo EN CERO
      // y despues anima desde ahi. Sintomas: "doble recarga" (el segundo
      // redibujo, al adoptar la respuesta del servidor, la recargaba entera) y
      // la barra re-animando aunque el envio gratis ya estuviera cumplido.
      // Siempre se fija primero, sin transicion, en lo que YA se veia; solo
      // anima si el valor cambio.
      const desde = prog != null && !lento ? prog : p;
      barra.style.transition = 'none';
      barra.style.transform = 'scaleX(' + desde.toFixed(4) + ')';
      void barra.offsetWidth;
      barra.style.transition = '';
      if (desde !== p) barra.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    prog = barra ? p : null;
    if (foco && abierto) {
      const sel = '[data-eq-act="' + foco.act + '"]' + (foco.key ? '[data-key="' + CSS.escape(foco.key) + '"]' : '');
      const el = panel.querySelector(sel);
      if (el && !el.disabled) el.focus({ preventScroll: true });
      else { const x = panel.querySelector('.eq-bolsa__x'); if (x) x.focus({ preventScroll: true }); }
    }
  };

  // ---- estado compartido con el resto de la pagina ----------------------
  const avisar = () => {
    window.dispatchEvent(new CustomEvent('eq:cart', { detail: { item_count: D.count, total_price: D.subtotal, eqBolsa: true } }));
    window.dispatchEvent(new CustomEvent('eq:bolsa-cambio'));
  };
  const adoptar = (datos) => {
    if (!datos) return;
    if (animando) { diferido = datos; return; }
    D = datos;
    if (abierto) render();
    avisar();
  };

  // ---- red ----------------------------------------------------------------
  const post = async (url, body) => {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    let j = null;
    try { j = await r.json(); } catch (e) {}
    if (!r.ok) throw new Error((j && j.description) || 'carrito ' + r.status);
    return j;
  };
  const parsear = (h) => (h ? leer(new DOMParser().parseFromString(h, 'text/html')) : null);
  const traer = async () => {
    const r = await fetch(ROOT + (ROOT.indexOf('?') === -1 ? '?' : '&') + 'sections=' + SEC, { headers: { Accept: 'application/json' } });
    const j = await r.json();
    return parsear(j && j[SEC]);
  };
  const deRespuesta = async (j) => parsear(j && j.sections && j.sections[SEC]) || traer();
  // todo cambio entra en cola; solo la ULTIMA respuesta se adopta, asi un
  // click rapido no ve su numero volver atras por una respuesta vieja
  const encolar = (tarea) => {
    pend++;
    cola = cola.then(async () => {
      let datos = null;
      try { datos = await deRespuesta(await tarea()); }
      catch (err) { try { datos = await traer(); } catch (e2) {} }
      pend--;
      if (pend === 0) adoptar(datos);
    });
    return cola;
  };
  const R = (window.EQ_SHOP && window.EQ_SHOP.routes) || {};

  const cambiar = (key, dn) => {
    const it = D.items.find((x) => x.key === key);
    if (!it) return;
    const n = Math.max(1, Math.min(it.max || 9, it.n + dn));
    if (n === it.n) return;
    it.n = n; recalcular(); render();
    encolar(() => post(R.cartChange || '/cart/change.js', { id: key, quantity: n, sections: SEC }));
  };
  // la fila se recorta hacia la derecha, se pliega, y RECIEN ahi sale del estado
  const quitar = (key) => {
    const row = panel.querySelector('[data-eq-item][data-key="' + CSS.escape(key) + '"]');
    const fuera = () => { D.items = D.items.filter((x) => x.key !== key); recalcular(); render(); };
    encolar(() => post(R.cartChange || '/cart/change.js', { id: key, quantity: 0, sections: SEC }));
    if (!row || lento) { fuera(); return; }
    animando++;
    row.querySelectorAll('button').forEach((b) => { b.disabled = true; });
    const h = row.offsetHeight;
    row.style.overflow = 'hidden';
    const a = row.animate([
      { height: h + 'px', opacity: 1, clipPath: 'inset(0 0 0 0)' },
      { height: h + 'px', opacity: 0, clipPath: 'inset(0 0 0 100%)', offset: 0.45 },
      { height: '0px', opacity: 0, clipPath: 'inset(0 0 0 100%)', paddingTop: '0px', paddingBottom: '0px', borderBottomWidth: '0px' }
    ], { duration: 520, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'forwards' });
    a.onfinish = () => {
      animando--;
      fuera();
      if (!animando && diferido) { const d = diferido; diferido = null; adoptar(d); }
    };
  };
  const sumarSug = (btn) => {
    btn.disabled = true;
    encolar(() => post(R.cartAdd || '/cart/add.js', { items: [{ id: Number(btn.dataset.key), quantity: 1 }], sections: SEC }));
  };

  // ---- panel ----------------------------------------------------------------
  const bloques = () => Array.from(panel.querySelectorAll('[data-eq-b]'));
  const cancelar = () => [panel, velo].concat(bloques()).forEach((el) => el.getAnimations().forEach((a) => a.cancel()));
  const abrir = () => {
    if (abierto) return;
    cerrarAviso(true); // al abrir el panel, el aviso se va al instante
    abierto = true;
    volverA = document.activeElement;
    const de = document.documentElement;
    overflowAntes = de.style.overflow;
    paddingAntes = de.style.paddingRight;
    // Bloquear el scroll saca la barra de scroll (en Windows ocupa ~15px): la
    // pagina se ensanchaba y todo lo centrado se corria a la derecha al abrir.
    // Se le devuelve ese ancho como padding, asi el contenido no se mueve.
    const barraScroll = window.innerWidth - de.clientWidth;
    de.style.overflow = 'hidden';
    if (barraScroll > 0) de.style.paddingRight = barraScroll + 'px';
    prog = null;
    render();
    cancelar();
    root.style.visibility = 'visible';
    root.style.pointerEvents = 'auto';
    panel.style.transform = 'translateX(0)';
    velo.style.opacity = '1';
    const bs = bloques();
    bs.forEach((el) => { el.style.clipPath = 'inset(-18px)'; el.style.opacity = '1'; });
    if (!lento) {
      panel.animate([{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }], { duration: 680, easing: 'cubic-bezier(.22,1,.36,1)' });
      velo.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 420, easing: 'linear' });
      bs.forEach((el, i) => el.animate(
        [{ clipPath: 'inset(100% -18px 0 -18px)', opacity: 0 }, { clipPath: 'inset(-18px)', opacity: 1 }],
        { duration: 460, delay: 150 + Math.min(i, 7) * 55, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'backwards' }));
    }
    clearTimeout(tFoco);
    tFoco = setTimeout(() => { const b = panel.querySelector('.eq-bolsa__x'); if (b && abierto) b.focus({ preventScroll: true }); }, 80);
  };
  const cerrar = () => {
    if (!abierto) return;
    abierto = false;
    cancelar();
    panel.style.transform = 'translateX(100%)';
    velo.style.opacity = '0';
    const fin = () => {
      if (abierto) return;
      root.style.visibility = 'hidden';
      root.style.pointerEvents = 'none';
      document.documentElement.style.overflow = overflowAntes || '';
      document.documentElement.style.paddingRight = paddingAntes || '';
      if (volverA && volverA.focus) volverA.focus({ preventScroll: true });
    };
    if (lento) { fin(); return; }
    velo.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 340, easing: 'linear' });
    panel.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }], { duration: 440, easing: 'cubic-bezier(.6,0,.8,.2)' }).onfinish = fin;
  };

  // ---- aviso de "sumado a la bolsa" -----------------------------------------
  // Cuelga del header, alineado a la bolsa. Se desenrolla desde el borde del
  // header; el objeto, que asomaba de su funda, se enfunda (vinilo/CD; el
  // cassette hace un clac de tope) y recien ahi se registra el texto donde
  // estaba. Sale plegandose hacia arriba. Estado final siempre inline.
  // Sale solo con el alta CONFIRMADA (eq-cart.js emite eq:bolsaSumar despues
  // de add.js) y cuando el trazo del boton cerro la vuelta: el numero de la
  // bolsa, "Sumado" y el aviso son un mismo instante.
  const av = root.parentElement && root.parentElement.querySelector('[data-eq-bolsa-aviso]');
  const avq = (s) => av.querySelector(s);
  let avVisible = false, tAviso = 0, tAvisoIn = 0, avGen = 0;
  const E_REG = 'cubic-bezier(.65,0,.35,1)';
  // la portada decodificada antes de mostrar: si no, el aviso cae con el hueco gris
  const portadaLista = (src) => new Promise((r) => {
    if (!src) { r(); return; }
    const im = new Image();
    im.src = src;
    (im.decode ? im.decode() : Promise.resolve()).then(r, r);
    setTimeout(r, 450);
  });
  // el renglon de envio del header vive lo mismo que el aviso (aparece con el y
  // se va con el, incluida la pausa del hover); flota, asi que no mueve nada
  const renglonEnvio = (on) => document.querySelectorAll('[data-eq-envio-sub]').forEach((el) => el.classList.toggle('is-temp', on));
  const programarCierre = (ms) => { clearTimeout(tAviso); tAviso = setTimeout(() => cerrarAviso(), ms); };
  const cerrarAviso = (ya) => {
    clearTimeout(tAviso); clearTimeout(tAvisoIn); avGen++;
    renglonEnvio(false);
    if (!av || !avVisible) return;
    avVisible = false;
    av.getAnimations().forEach((a) => a.cancel());
    av.style.pointerEvents = 'none';
    const fin = () => { if (avVisible) return; av.style.visibility = 'hidden'; };
    if (lento || ya === true) { fin(); return; }
    av.style.clipPath = 'inset(0 0 100% 0)';
    av.animate([{ clipPath: 'inset(0 0 0 0)' }, { clipPath: 'inset(0 0 100% 0)' }], { duration: 300, easing: 'cubic-bezier(.6,0,.8,.2)' }).onfinish = fin;
  };
  const abrirAviso = (d) => {
    if (!av || abierto) return;
    const disco = avq('[data-eq-bolsa-aviso-disco]'), casete = avq('[data-eq-bolsa-aviso-casete]');
    const bloques = Array.from(av.querySelectorAll('[data-eq-bolsa-aviso-b]'));
    avq('[data-eq-bolsa-aviso-t]').textContent = d.t || '';
    avq('[data-eq-bolsa-aviso-m]').textContent = [d.a, d.fmt].filter(Boolean).join(' · ') + (d.n > 1 ? ' · × ' + d.n : '');
    avq('[data-eq-bolsa-aviso-tapa]').style.backgroundImage = d.img ? 'url("' + String(d.img).replace(/"/g, '%22') + '")' : 'none';
    const fmt = String(d.fmt || '').toLowerCase();
    const esCasete = fmt.indexOf('cassette') >= 0;
    disco.style.display = esCasete ? 'none' : 'block';
    disco.classList.toggle('is-cd', fmt === 'cd');
    casete.style.display = esCasete ? 'block' : 'none';
    const obj = esCasete ? casete : disco;
    // posicion: 12px bajo el header (o 16px si no se ve) y alineado a la bolsa;
    // clientWidth, no innerWidth (que cuenta la barra de scroll)
    const bag = document.querySelector('[data-eq-bolsa-btn]');
    const hdr = bag && (bag.closest('.eq-sec-header') || bag.closest('header'));
    const hb = hdr ? hdr.getBoundingClientRect().bottom : 0;
    av.style.top = (hb > 0 ? hb + 12 : 16) + 'px';
    av.style.right = (bag ? Math.max(16, document.documentElement.clientWidth - bag.getBoundingClientRect().right) : 24) + 'px';
    const ya = avVisible;
    [av, disco, casete].concat(bloques).forEach((n) => n.getAnimations().forEach((a) => a.cancel()));
    av.style.visibility = 'visible';
    av.style.pointerEvents = 'auto';
    av.style.clipPath = 'none';
    disco.style.transform = 'translateX(0)';
    casete.style.transform = 'translateX(0)';
    bloques.forEach((b) => { b.style.clipPath = 'inset(-18px)'; b.style.opacity = '1'; });
    avVisible = true;
    renglonEnvio(true);
    if (!lento) {
      if (!ya) av.animate([{ clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0 0)' }], { duration: 380, easing: E_REG });
      if (esCasete) {
        // la cinta entra en su estuche y hace tope: el clac
        obj.animate([
          { transform: 'translateX(40px)', easing: 'cubic-bezier(.3,0,.2,1)' },
          { transform: 'translateX(-1.5px)', offset: 0.78, easing: 'ease-out' },
          { transform: 'translateX(0)' }
        ], { duration: 560, delay: ya ? 0 : 260, fill: 'backwards' });
      } else {
        obj.animate([{ transform: 'translateX(40px)' }, { transform: 'translateX(0)' }],
          { duration: 540, delay: ya ? 0 : 260, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
      }
      bloques.forEach((b, i) => b.animate(
        [{ clipPath: 'inset(100% -18px 0 -18px)', opacity: 0 }, { clipPath: 'inset(-18px)', opacity: 1 }],
        { duration: 380, delay: (ya ? 240 : 560) + i * 60, easing: E_REG, fill: 'backwards' }));
    }
    programarCierre(4600);
  };
  const onSumar = (e) => {
    const d = (e && e.detail) || {};
    if (!d.t || abierto) return;
    const gen = ++avGen;
    clearTimeout(tAvisoIn);
    // espera a que el trazo cierre (tope 900ms) y a la portada decodificada
    const falta = Math.max(0, Math.min(900, (window.__eqTrazoFin || 0) - performance.now()));
    Promise.all([new Promise((r) => { tAvisoIn = setTimeout(r, falta); }), portadaLista(d.img)])
      .then(() => { if (gen === avGen) abrirAviso(d); });
  };
  const onAvIn = () => clearTimeout(tAviso);
  const onAvOut = () => { if (avVisible) programarCierre(2400); };
  const onAvClick = (e) => {
    if (e.target.closest('[data-eq-bolsa-aviso-x]')) cerrarAviso();
    else if (e.target.closest('[data-eq-bolsa-aviso-ver]')) { cerrarAviso(true); abrir(); }
  };
  if (av) {
    av.addEventListener('pointerenter', onAvIn);
    av.addEventListener('pointerleave', onAvOut);
    av.addEventListener('click', onAvClick);
  }

  // ---- eventos -------------------------------------------------------------
  const onBtn = (e) => {
    const b = e.target.closest && e.target.closest('[data-eq-bolsa-btn]');
    if (!b || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    abrir();
  };
  const onPanel = (e) => {
    const b = e.target.closest('[data-eq-act]');
    if (!b || b.disabled) return;
    const act = b.dataset.eqAct, key = b.dataset.key;
    if (act === 'cerrar') cerrar();
    else if (act === 'menos') cambiar(key, -1);
    else if (act === 'mas') cambiar(key, 1);
    else if (act === 'quitar') quitar(key);
    else if (act === 'sug') sumarSug(b);
  };
  const onKey = (e) => { if (e.key === 'Escape' && abierto) cerrar(); };
  // lo que se suma desde el resto de la pagina: se trae en segundo plano, asi
  // al abrir ya esta al dia (sin esperar la red)
  let tTraer = 0;
  const onCart = (e) => {
    if (e.detail && e.detail.eqBolsa) return;
    clearTimeout(tTraer);
    tTraer = setTimeout(() => { if (!pend) traer().then((d) => { if (d && !pend) { D = d; if (abierto) render(); } }).catch(() => {}); }, 120);
  };

  document.addEventListener('click', onBtn);
  panel.addEventListener('click', onPanel);
  velo.addEventListener('click', cerrar);
  document.addEventListener('keydown', onKey);
  window.addEventListener('eq:cart', onCart);
  window.addEventListener('eq:bolsaSumar', onSumar);

  return () => {
    window.removeEventListener('eq:bolsaSumar', onSumar);
    if (av) {
      av.removeEventListener('pointerenter', onAvIn);
      av.removeEventListener('pointerleave', onAvOut);
      av.removeEventListener('click', onAvClick);
    }
    clearTimeout(tAviso); clearTimeout(tAvisoIn);
    document.removeEventListener('click', onBtn);
    panel.removeEventListener('click', onPanel);
    velo.removeEventListener('click', cerrar);
    document.removeEventListener('keydown', onKey);
    window.removeEventListener('eq:cart', onCart);
    clearTimeout(tFoco); clearTimeout(tTraer);
    if (abierto) { document.documentElement.style.overflow = overflowAntes || ''; document.documentElement.style.paddingRight = paddingAntes || ''; }
  };
});
